import { UserDto } from './apiClient';

export const DOCUMENTS_ALLOWED_PERSON_ID = 1328;

export function canAccessDocuments(user: UserDto | undefined, isOwner: boolean): boolean {
  if (!user) return false;
  if (isOwner) return true;
  return Number(user.id) === DOCUMENTS_ALLOWED_PERSON_ID;
}
